/**
 * Unified events portal (single CRM) — all "Eventi" links point here and every
 * site lead form ships its payload to the portal bridge through the backend
 * proxy (/api/bridge/*), avoiding CORS issues on any domain.
 */
import { getLeadTracking } from '@/lib/leadTracking';

export const EVENTS_PORTAL_URL = 'https://eventi.primevision.app/';
export const EVENTS_PORTAL_ADMIN_URL = 'https://eventi.primevision.app/admin';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export function buildBridgeLead(form, origin, extra = {}) {
  let pathname = '';
  try {
    pathname = window.location.pathname;
  } catch {
    /* SSR */
  }
  const payload = {
    first_name: (form.first_name || '').trim(),
    last_name: (form.last_name || '').trim(),
    email: (form.email || '').trim().toLowerCase(),
    privacy_consent: !!form.privacy_consent,
    newsletter_consent: !!form.email_newsletter_consent,
    whatsapp_consent: !!form.whatsapp_newsletter_consent,
    source: `${origin} · ${pathname || '/'}`,
  };
  if (form.phone && form.phone.trim()) payload.phone = form.phone.trim();
  if (form.city && form.city.trim()) payload.city = form.city.trim();
  const t = getLeadTracking();
  payload.page_url = t.source_page_url || '';
  payload.referrer = t.source_referrer || '';
  UTM_KEYS.forEach((k) => {
    if (t[k]) payload[k] = t[k];
  });
  return { ...payload, ...extra };
}
